import React, {useEffect, useState, useRef} from 'react';
import {WEEK_FORMAT, FORMAT} from './utils/moment-formats';
import 'moment/locale/de';
import moment from 'moment';
import {getFreeTimes} from './utils/endpoints';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import Loader from 'react-loader-spinner';
import {BASE_URL} from './utils/constants';
import {SELECTED_DAY_FORMAT} from './utils/moment-formats';
import {genderTypes} from './utils/constants';
import {useFormik} from 'formik';
import dropdown from './img/dropdown.svg';
import checkImg from './img/check.svg';
import calendarImg from './assets/images/calendar.svg'
import * as Yup from 'yup';

import './calendar.scss';
import './index.scss';

const INITIAL_STATE = {
  insuranceTypes: [],
  medTypes: [],
  currentDate: moment().format('YYYY-MM-DD'),
  isLoading: false,
  selectedTime: null,
  showTimePicker: true,
  selectedInsuranceType: null,
  selectedMedType: null,
  showVerificationField: false,
  isVerified: null,
  userInfo: {
    firstName: null, lastName: null, genderType: null, phone: null, email: null, id: null,
  },
  hasOwn: false,
  step: 1,
};

const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
const phoneRegExp = /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;

const userInfoScheme = Yup.object().shape({
  firstName: Yup.string().required('Vorname ist erforderlich'),
  lastName: Yup.string().required('Nachname ist erforderlich'),
  phone: Yup.string()
    .required('Telefonnummer ist erforderlich')
    .matches(phoneRegExp, 'Telefonnummer ist ungültig'),
  email: Yup.string()
    .required('E-Mail Adresse wird benötigt')
    .min(1, 'E-Mail Adresse wird benötigt')
    .test('email-test', 'Bitte schreiben Sie eine gültige E-Mail-Adresse', email => emailRegExp.test(email),),
  newPatient: Yup.boolean().required('New patient ist erforderlich'),
});

const codeScheme = Yup.object().shape({
  code: Yup.string().required('Code erforderlich'),
});

const debounce = (func, wait) => {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};
const InsuranceSection = ({
                            selectedInsuranceType, insuranceTypes, selectInsurance, step, setShowModal, selectedMedType,
                          }) => {
  return (<div className="c_calendar-section-step">
    {step <= 1 && !selectedMedType && (<>
      <div className="c_calendar-section-step-content">
        <div className="c_calendar-section-step-subtitle">Versicherungsart wählen:</div>
        <div className="c_drop-down">
          <div className="c_drop-down-menu" aria-labelledby="insuranceType">
            {insuranceTypes.map(([insurance]) => {
              return (<div
                key={insurance}
                className="c_drop-down-item"
                onClick={() => {
                  selectInsurance(insurance);
                  setShowModal(true);
                }}
                style={{
                  color: insurance === selectedInsuranceType && '#F85B00',
                  fontWeight: insurance === selectedInsuranceType && '700',
                }}
              >
                {insurance === selectedInsuranceType ? (<div className="c_checkImg">
                  <img src={checkImg} alt=""/>
                </div>) : ('')}
                {insurance}
                {insurance === selectedInsuranceType ? (<div
                  className="c_checkImg"
                  style={{backgroundColor: 'transparent', boxShadow: 'none'}}
                />) : ('')}
              </div>);
            })}
          </div>
        </div>
      </div>
    </>)}
  </div>);
};
const MedSection = ({
                      medTypes, selectedMedType, selectMedType, showModal, setShowModal, setMedLength,
                    }) => {
  const [key, data] = medTypes;
  return (<div className="c_calendar-section-step">
    <div
      className="c_calendar-section-step-content"
      style={{borderRadius: selectedMedType && '0'}}
    >
      <div
        className="c_drop-down"
        style={{
          boxShadow: showModal && 'none',
          opacity: showModal ? '1' : '0',
          visibility: showModal ? 'visible' : 'hidden',
          transform: showModal ? 'translateY(0)' : 'translateY(-500vh)',
          position: showModal ? 'static' : 'absolute',
          transition: 'opacity .8s',
          zIndex: showModal ? '0' : '-1',
        }}
      >
        <div className="c_drop-down-menu" aria-labelledby="treatmentReason">
          {data.map(item => {
            return (<div
              style={{
                color: selectedMedType?.med_id === item.med_id && '#F85B00',
                fontWeight: selectedMedType?.med_id === item.med_id && '700',
              }}
              key={item.med_id}
              className="c_drop-down-item cursor-pointer"
              onClick={() => {
                selectMedType({...item, isChecked: true});
                setShowModal(data?.length <= 1 && true);
                setMedLength(data?.length);

              }}
            >
              {selectedMedType?.med_id === item.med_id ? (<div className="c_checkImg">
                <img src={checkImg} alt=""/>
              </div>) : ('')}
              {item.med_type}
              {selectedMedType?.med_id === item.med_id ? (<div
                className="c_checkImg"
                style={{backgroundColor: 'transparent', boxShadow: 'none'}}
              />) : ('')}
            </div>);
          })}
        </div>
      </div>
    </div>
  </div>);
};

const UserForm = ({
                    selectedTime,
                    userInfo: {genderType, firstName, lastName, phone, email, newPatient},
                    selectGender,
                    showVerificationField,
                    selectedMedType,
                    setState,
                    selectedInsuranceType,
                    getInitialData,
                    setMedLength,
                    medTypes,
                    setShowModal
                  }) => {
  const [resendProps, setResendProps] = useState(false);
  const [error, setError] = useState();
  const [isVerifying, setIsVerifying] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [showGenMenu, setShowGenMenu] = useState(false);

  const scrollElement = useRef(null);
  const executeScroll = () => scrollElement.current.scrollIntoView();

  const register = async ({email, firstName, lastName, phone, newPatient}) => {
    setError(false);
    executeScroll();
    const data = {
      email,
      name: firstName,
      surname: lastName,
      phonenumber: phone,
      gender: genderType,
      new_patient: newPatient,
      med_id: selectedMedType.med_id,
      date: `${moment(selectedTime[0]).format('YYYY-MM-DD')} ${selectedTime[1]}`,
    };
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => formData.append(key, value));

    const options = {
      method: 'POST', body: formData, redirect: 'follow',
    };

    const res = await (await fetch(`${BASE_URL}/api/Email/register/`, options)).json();

    if (res.done === 'true') {
      setState(prev => ({
        ...prev, userInfo: {...prev.userInfo, id: res.id}, showVerificationField: true,
      }));
      setError(null);
      setIsVerifying(false);
    } else {
      setIsVerifying(false);
      setError(res.error);
    }
  };

  const handleSubmit = debounce(async ({email, firstName, lastName, phone, newPatient, code}) => {
    setIsVerifying(true);
    executeScroll();
    if (genderType) {
      if (!showVerificationField) {
        await register({email, firstName, lastName, phone, newPatient, code});
      } else {
        setError(false);
        const verifyData = new FormData();
        verifyData.append('email', email);
        verifyData.append('token', code);
        verifyData.append('date', `${moment(selectedTime[0], 'YYYY-MM-DD mm').format('YYYY-MM-DD')} ${selectedTime[1]}`,);
        const options = {
          method: 'POST', body: verifyData, redirect: 'follow',
        };
        const {done, error} = await (await fetch(`${BASE_URL}/api/EventList/post_time/`, options)).json();

        if (done === 'true') {
          setIsVerifying(false);
          setIsVerified(true);
          setState(prev => ({...prev, isVerified: true}));
          return null;
        }
        setError(error);
        setIsVerifying(false);
        setIsVerified(false);
      }
    }
  }, 300);

  const isInitialValid = () => email && firstName && lastName && phone && newPatient && true;

  const formikProps = useFormik({
    onSubmit: handleSubmit,
    validationSchema: showVerificationField ? codeScheme : userInfoScheme,
    initialValues: showVerificationField ? {code: ''} : {
      email: email || '',
      firstName: firstName || '',
      lastName: lastName || '',
      phone: phone || '',
      newPatient: newPatient || '',
    },
    validateOnChange: true,
    isInitialValid: showVerificationField || isInitialValid(),
  });

  const onBack = () => {
    setMedLength(medTypes);
    getInitialData();
    executeScroll();
    setState(prev => ({
      ...prev,
      userInfo: {...prev.userInfo, ...formikProps.values},
      selectedTime: null,
      showTimePicker: true,
      showVerificationField: false,
      selectedMedType: selectedTime ? selectedMedType : null,
      selectedInsuranceType: selectedInsuranceType,
      step: 1,
    }));
  };

  return (<>
    {selectedTime && !isVerified && (
      <div style={{zIndex: "999"}} className="c_prev-step-form" onClick={() => onBack()}>
        <img src={dropdown} alt=""/>
      </div>)}
    <div className="c_code-send-form">
      <div className="c_anchor-link" ref={scrollElement}/>
      {!isVerified && (<div className="c_code-send-form-header">
        <p>Ihr Termin</p>
        <p className="c_selected-date-time">
          {moment(selectedTime[0], 'YYYY-MM-DD mm').format(SELECTED_DAY_FORMAT)}{' '}
          {selectedTime[1]}
        </p>
      </div>)}
      <section className="c_contacts-container">
        <form onSubmit={formikProps.handleSubmit}>
          {!showVerificationField && (<div className="c_kontaktdaten-form-container">
            <div className="c_new-patient">
              <p className="c_new-patient__question">Neu bei uns?</p>
              <div className="c_label-radio">
                <label className="c_new-patient__label">
                  <p>Ja</p>
                  <input
                    type="radio"
                    value={true}
                    checked={formikProps.values.newPatient === 'true'}
                    name="newPatient"
                    onChange={() => formikProps.setFieldValue('newPatient', 'true')}
                  />
                  <span/>
                </label>
                <label className="c_new-patient__label">
                  <p>Nein</p>
                  <input
                    type="radio"
                    value={false}
                    checked={formikProps.values.newPatient === 'false'}
                    name="newPatient"
                    onChange={() => formikProps.setFieldValue('newPatient', 'false')}
                  />
                  <span/>
                </label>
              </div>
            </div>
            <div className="c_drop-down">
              <button
                onClick={() => setShowGenMenu(!showGenMenu)}
                className="c_open-menu"
                type="button"
                id="insuranceType"
                style={{color: genderType ? '#570000' : '#C5C5C5'}}
              >
                {genderType || 'Wähle Geschlecht'}
                <img
                  src={dropdown}
                  alt=""
                  style={{transform: showGenMenu ? 'rotateZ(180deg)' : 'rotateZ(0)'}}
                />
              </button>
              <div
                className="c_drop-down-menu"
                style={{
                  display: showGenMenu ? 'flex' : 'none',
                  opacity: showGenMenu ? '1' : '0',
                  visibility: showGenMenu ? 'visible' : 'hidden',
                  transform: showGenMenu ? 'translateY(0)' : 'translateY(-200%)',
                  position: showGenMenu ? 'static' : 'absolute',
                }}
              >
                {genderTypes?.map(item => (<div
                  key={item.id + 1}
                  className="c_drop-down-item cursor-pointer"
                  style={{}}
                  onClick={() => {
                    selectGender(item.name);
                    setShowGenMenu(false);
                  }}
                >
                  {genderType === item?.name && (<div className="c_checkImg">
                    <img src={checkImg} alt=""/>
                  </div>)}
                  {item.name}
                  {genderType === item?.name ? (<div
                    className="c_checkImg"
                    style={{backgroundColor: 'transparent', boxShadow: 'none'}}
                  />) : ('')}
                </div>))}
              </div>
            </div>
            <input
              placeholder="Vorname"
              type="text"
              name="firstName"
              className="c_kontaktdaten-item"
              value={formikProps.values.firstName}
              onChange={formikProps.handleChange}
              onBlur={formikProps.handleBlur}
            />
            {formikProps.touched.firstName && formikProps.errors.firstName && (
              <span style={{color: 'red', fontSize: '14px', padding: '5px 0'}}>
                    {formikProps.errors.firstName}
                  </span>)}
            <input
              placeholder="Nachname"
              type="text"
              name="lastName"
              className="c_kontaktdaten-item"
              value={formikProps.values.lastName}
              onChange={formikProps.handleChange}
              onBlur={formikProps.handleBlur}
            />
            {formikProps.touched.lastName && formikProps.errors.lastName && (
              <span style={{color: 'red', fontSize: '14px', padding: '5px 0'}}>
                    {formikProps.errors.lastName}
                  </span>)}

            <div className="c_kontaktdaten-item-container">
              <input
                placeholder="017612345678"
                type="phone"
                name="phone"
                className="c_kontaktdaten-item"
                value={formikProps.values.phone}
                onChange={formikProps.handleChange}
                onBlur={formikProps.handleBlur}
              />
              {formikProps.touched.phone && formikProps.errors.phone && (<span
                style={{
                  color: 'red',
                  fontSize: '14px',
                  padding: '5px 0',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                      {formikProps.errors.phone}
                    </span>)}
              <input
                placeholder="E-Mail"
                type="email"
                name="email"
                className="c_kontaktdaten-item"
                value={formikProps.values.email}
                onChange={formikProps.handleChange}
                onBlur={formikProps.handleBlur}
              />
              {formikProps.touched.email && formikProps.errors.email && (
                <div className="c_d-flex justify-content-center">
                      <span
                        style={{
                          color: 'red',
                          fontSize: '14px',
                          padding: '5px 0',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        {formikProps.errors.email}
                      </span>
                </div>)}
              <label htmlFor="" className="c_bottom-text">
                Sie erhalten einen Aktivierungs-Code, den wir Ihnen per SMS bzw. E-Mail senden.
              </label>
            </div>
          </div>)}

          {showVerificationField && !isVerified && (<div className="c_code-sended-container">
            <p className="c_check-email-notification" style={{textAlign: 'center'}}>
              Bitte bestätigen Sie den Termin mit dem Code, den Sie jetzt von uns per SMS bzw. E-Mail
              erhalten haben
            </p>
            <p className="c_check-email-notification" style={{padding: '0  0 20px'}}>
              (gültig für 30 min).
            </p>
            <p
              className="c_resend"
              onClick={() => {
                register({...formikProps.values});
                setResendProps(true);
              }}
            >
              {!showVerificationField ? (
                <Loader type="TailSpin" color="#f85b00" height={25} width={25}/>) : ('Code erneut senden')}
            </p>
            {resendProps && !isVerifying && showVerificationField ? (
              <h5 style={{color: 'green'}}>Code erneut versendet</h5>) : ('')}
            <label htmlFor="" className="c_resend-label">
              {genderType} / {formikProps.values.firstName} / {formikProps.values.lastName} /{' '}
              {formikProps.values.email} / {formikProps.values.phone}
            </label>
            <input
              placeholder="Code"
              type="text"
              name="code"
              value={formikProps.values.code}
              onChange={formikProps.handleChange}
              onBlur={formikProps.handleBlur}
              style={{width: '30%', textAlign: 'center'}}
              autoFocus
            />
            {formikProps.touched.code && formikProps.errors.code && (
              <span style={{color: 'red', fontSize: '14px', padding: '5px 0'}}>
                    {formikProps.errors.code}
                  </span>)}
          </div>)}

          {error && (<p
            className="c_text-center"
            style={{color: 'red', fontSize: '14px', paddingBottom: '10px'}}
          >
            {error}
          </p>)}

          {!isVerified && (<button
            type="submit"
            className="c_kontaktdaten-item-sender"
            disabled={!formikProps.isValid && !genderType}
            style={{
              cursor: formikProps.isValid && genderType ? 'pointer' : 'not-allowed',
              backgroundColor: formikProps.isValid && genderType ? '#f85b00' : 'rgba(248, 91, 0, 0.5)',
            }}
            onClick={formikProps.handleSubmit}
          >
            {isVerifying ? (<Loader type="TailSpin" color="#f85b00" height={35} width={35}/>) : ('Code senden')}
          </button>)}
        </form>

        {isVerified && (<div className="c_success-notification">
          <div>
            <h3>Vielen Dank! Den ausgewählten Termin</h3>
            <h4>
                  <span>
                    am {moment(selectedTime[0], 'YYYY-MM-DD mm').format(SELECTED_DAY_FORMAT)} um{' '}
                    {selectedTime[1]}
                  </span>
            </h4>
            <p>Haben wir erfolgreich gebucht.</p>
            <p>
              Bitte bringen Sie zu Ihrem Termin die Gesundheitskarte mit. Sollten Sie den Termin
              nicht einhalten können, sagen Sie bitte mindestens 24 Stunden vorher ab.
            </p>
            <button
              className="nextFreeTime"
              onClick={() => {
                setState(prev => ({
                  ...prev,
                  isVerified: false,
                  isLoading: false,
                  selectedTime: null,
                  showTimePicker: false,
                  showVerificationField: false,
                  selectedMedType: null,
                  selectedInsuranceType: selectedInsuranceType,
                  step: 1,
                }));
                setShowModal(true)
              }}>Weiteren Termin nehmen
            </button>
          </div>
        </div>)}
      </section>
    </div>
  </>);
};

const App = () => {
  const [{
    selectedInsuranceType,
    insuranceTypes,
    selectedMedType,
    availableHours,
    currentDate,
    isLoading,
    selectedTime,
    showTimePicker,
    userInfo,
    showVerificationField,
    isVerified,
    step,
    hasOwn,
  }, setState,] = useState(() => INITIAL_STATE);
  const [freeDay, setFreeDay] = useState(false)
  const [nextFreeDay, setNextFreeDay] = useState("")
  const [nextFreeWeek, setNextFreeWeek] = useState("")
  const weekDaysContainerRef = useRef(null)

  const medTypes = insuranceTypes.length === 1 ? insuranceTypes[0] : insuranceTypes.find(([key]) => key === selectedInsuranceType);

  const [medLength, setMedLength] = useState(0);

  const onBack = () => {
    getInitialData();
    executeScroll();
    setState(prev => ({
      ...prev,
      selectedTime: null,
      showTimePicker: true,
      showVerificationField: false,
      selectedMedType: selectedTime ? selectedMedType : null,
      step: 1,
    }));
  };

  const [showModal, setShowModal] = useState(insuranceTypes.length > 0 ? false : true);

  useEffect(() => {
    (async () => {
      setState(prev => ({...prev, isLoading: true}));
      const {response} = await (await fetch(`${BASE_URL}/api/EventList/get_med_types/`, {
        method: 'GET',
      })).json();
      const converted = Object.entries(response);

      if (converted && converted?.length === 1 && converted[0][1]?.length === 1) {
        setState(prev => ({
          ...prev,
          selectedMedType: converted[0][1][0],
          hasOwn: true
        }));
      }else {
        setState(prev => ({
          ...prev,
          hasOwn: false
        }));
      }

      setState(prev => ({
        ...prev,
        insuranceTypes: converted,
        selectedInsuranceType: converted.length > 1 ? null : converted[0],
        isLoading: false,
      }));
    })();
  }, []);

  const scrollElement = useRef(null);
  const executeScroll = () => scrollElement.current.scrollIntoView();

  const selectInsurance = type => setState(prev => ({
    ...prev, selectedInsuranceType: type, selectedMedType: null,
  }));

  const selectMedType = type => setState(prev => ({...prev, selectedMedType: type}));

  useEffect(() => {
    if (selectedMedType) {
      getInitialData();
      setState(prev => ({...prev, showTimePicker: true}))
    }
  }, [selectedMedType]);

  const getInitialData = async () => {
    setState(prev => ({...prev, isLoading: true}));
    const currentWeek = moment();
    const currentMonday = currentWeek.day(1).format('YYYY-MM-DD');

    const {response} = await (await fetch(`${BASE_URL}/api/EventList/get_free_time/?med_id=${selectedMedType.med_id}&min=${currentMonday}`, {
      method: 'GET',
    },)).json();
    if (response["free_day"]) {
      setFreeDay(true)
      setNextFreeDay(response["free_day"].next_free_day)
      setNextFreeWeek(response["free_day"].monday)
    } else {
      setNextFreeDay('')
      setNextFreeWeek('')
      setFreeDay(false)
    }
    setState(prev => ({
      ...prev,
      currentDate: moment().format('YYYY-MM-DD'),
      availableHours: Object.entries(response["free_times"]).filter(([, value], i) => !(i >= 5 && !value.length)),
      isLoading: false,
    }));
  };

  const isSame = day => moment(moment().day(1).format('YYYY-MM-DD')).isSameOrAfter(moment(day, 'YYYY-MM-DD'));

  const getNextWeekDays = async () => {
    const nextWeek = moment(currentDate, 'YYYY-MM-DD').add(1, 'week');
    setState(prev => ({
      ...prev, currentDate: nextWeek, isLoading: true,
    }));
    const {response} = await (await fetch(`${getFreeTimes(selectedMedType.med_id, nextWeek.day(1).format('YYYY-MM-DD'))}`, {
      method: 'GET',
    })).json();
    if (response["free_day"]) {
      setFreeDay(true)
      setNextFreeDay(response["free_day"].next_free_day)
      setNextFreeWeek(response["free_day"].monday)
    }else {
      setFreeDay(false)
      setNextFreeDay("")
      setNextFreeWeek('')
    }
    setState(prev => ({
      ...prev,
      availableHours: Object.entries(response["free_times"]).filter(([, value], i) => !(i >= 5 && !value.length)),
      isLoading: false,
    }));
  };

  const getPrevWeekDays = async () => {
    if (!isSame(availableHours[0])) {
      const prevWeek = moment(currentDate, 'YYYY-MM-DD').subtract(1, 'week');
      setState(prev => ({
        ...prev, currentDate: prevWeek, isLoading: true,
      }));
      const endpoint = getFreeTimes(selectedMedType.med_id, prevWeek.day(1).format('YYYY-MM-DD'));

      const {response} = await (await fetch(`${endpoint}`, {
        method: 'GET',
      })).json();
      if (response["free_day"]) {
        setFreeDay(true)
        setNextFreeDay(response["free_day"].next_free_day)
        setNextFreeWeek(response["free_day"].monday)
      }else{
        setFreeDay(false)
        setNextFreeDay("")
        setNextFreeWeek('')
      }
      setState(prev => ({
        ...prev,
        availableHours: Object.entries(response["free_times"]).filter(([, value], i) => !(i >= 5 && !value.length),),
        isLoading: false,
      }));
    }
  };

  const getFreeDay = async () => {
    setState(prev => ({
      ...prev, currentDate: nextFreeWeek, isLoading: true,
    }));
    const {response} = await (await fetch(`${getFreeTimes(selectedMedType.med_id, nextFreeWeek)}`, {
      method: 'GET',
    })).json();
    setFreeDay(false)
    setState(prev => ({
      ...prev,
      availableHours: Object.entries(response["free_times"]).filter(([, value], i) => !(i >= 5 && !value.length)),
      isLoading: false,
    }));
  }

  const selectTime = time => {
    setState(prev => ({...prev, selectedTime: time, showTimePicker: false, step: 2}));
    executeScroll();
  };

  const selectGender = gender => setState(prev => ({...prev, userInfo: {...prev.userInfo, genderType: gender}}));

  useEffect(() => {
    if (weekDaysContainerRef && weekDaysContainerRef.current){
      if (availableHours && availableHours[0] && !availableHours[0][1].length && availableHours[1] && !availableHours[1][1].length) {
        weekDaysContainerRef.current.scrollLeft = weekDaysContainerRef.current.scrollWidth - weekDaysContainerRef.current.clientWidth;
      }
    }
  }, [weekDaysContainerRef, availableHours])

  return (<div className="c_main">
    <div className="c_calendar-section-container" ref={scrollElement}>
      <>
        <div className="c_calendar-section-title">Termin online buchen</div>
        {selectedInsuranceType && (<div className="c_calendar-section-subtitle">Behandlungsgrund wählen:</div>)}
        {isVerified || !selectedInsuranceType || (<button
          className="c_open-modal"
          style={{transform: showModal && 'rotateZ(180deg)'}}
          type="button"
          id="treatmentReason"
          onClick={() => setShowModal(!showModal)}
        >
          <img src={dropdown} alt=""/>
        </button>)}
        {!selectedMedType || isVerified || (<div
          className="c_prev-step"
          style={{display: hasOwn ? "none" : 'flex'}}
          onClick={() => {
            onBack();
            setShowModal(true);
          }}
        >
          <img src={dropdown} alt=""/>
        </div>)}
      </>
    </div>
    {selectedMedType && showModal === false && medLength > 1 && (<div className="c_selectedMedType">
      <div className="c_selectedMedTypeInnerText" key={selectMedType?.id}>
        <div className="c_checkImg">
          <img src={checkImg} alt=""/>
        </div>
        {selectedMedType?.med_type}
        <div
          className="c_checkImg"
          style={{backgroundColor: 'transparent', boxShadow: 'none'}}
        />
      </div>
    </div>)}
    <div className="c_calendar-section-steps">
      {!isLoading && selectedInsuranceType && !isVerified && step === 1 && (<MedSection
        selectMedType={selectMedType}
        showModal={showModal}
        setShowModal={setShowModal}
        medLength={medLength}
        setMedLength={setMedLength}
        medTypes={insuranceTypes.length === 1 ? insuranceTypes[0] : insuranceTypes.find(([key]) => key === selectedInsuranceType)}
        selectedMedType={selectedMedType}
        selectedInsuranceType={selectedInsuranceType}
      />)}
      {isLoading && <Loader type="TailSpin" color="#f85b00" height={100} width={100}/>}
      {!isLoading && !isVerified && insuranceTypes.length > 1 && (<InsuranceSection
        selectInsurance={selectInsurance}
        insuranceTypes={insuranceTypes}
        selectedInsuranceType={selectedInsuranceType}
        step={step}
        showModal={showModal}
        setShowModal={setShowModal}
        selectedMedType={selectedMedType}
      />)}

      {!isLoading && selectedMedType && availableHours && showTimePicker && (
        <div className="c_calendar-section-step w-100">
          <div className="c_calendar-section-step-content w-100">
            <div className="c_calendar-container">
              <div className="c_header">
                <div className="c_header-left" onClick={getPrevWeekDays}>
                  <div
                    className={`c_header-arrow c_arrow-left ${isSame(availableHours[0]) ? 'c-disabled' : ''}`}
                  >
                    <img src={dropdown} style={{transform: 'rotateZ(90deg)'}} alt=""/>
                  </div>
                </div>
                <div className="c_header-center">
                  {availableHours.length === 0 ? 'Bitte blättern Sie in die nächste Woche.' : moment(availableHours[0], 'YYYY-MM-DD').format('D. MMMM') + '-' + moment(availableHours[availableHours.length - 1], 'YYYY-MM-DD').format('D. MMMM',)}
                </div>
                <div className="c_header-right" onClick={getNextWeekDays}>
                  <div className="c_header-arrow arrow-right">
                    <img src={dropdown} style={{transform: 'rotateZ(-90deg)'}} alt=""/>
                  </div>
                </div>
              </div>
              <div className="c_body">
                <div className="c_week-days-container" ref={weekDaysContainerRef}>
                  {availableHours.map(([day, hours]) => {
                    const weekDay = moment(day);
                    weekDay.locale('de');
                    return (<div key={day} className="c_week-day">
                      <p>{weekDay.format(WEEK_FORMAT)}</p>
                      <p>{weekDay.format(FORMAT)}</p>

                      {hours.map((hour, idx) => (<div
                        key={hour + idx}
                        className='c_hours-column__item'
                        onClick={() => {
                          selectTime([moment(day).format('YYYY-MM-DD'), hour]);
                          setShowModal(false);
                          setMedLength(2);
                        }}
                      >
                        {hour}
                      </div>))}
                    </div>);
                  })}
                </div>
              </div>
              {freeDay && (<button className="nextFreeTime" onClick={() => {
                executeScroll()
                getFreeDay()
              }}>
                <img src={calendarImg} alt=""/>
                Nächster Termin am {moment(nextFreeDay, 'YYYY-MM-DD').format('D. MMMM')}
              </button>)}
            </div>
          </div>
        </div>)}
      {selectedTime && (<UserForm
        selectInsurance={selectInsurance}
        insuranceTypes={insuranceTypes}
        selectedInsuranceType={selectedInsuranceType}
        selectedMedType={selectedMedType}
        selectedTime={selectedTime}
        userInfo={userInfo}
        selectGender={selectGender}
        setState={setState}
        showVerificationField={showVerificationField}
        step={step}
        getInitialData={getInitialData}
        medTypes={medTypes?.[1].length}
        setMedLength={setMedLength}
        setShowModal={setShowModal}
      />)}
    </div>
  </div>);
};
export default App;
